module Client

open OnlineDPR.Application.Client
open OnlineDPR.Application.Client.State
open OnlineDPR.Application.Client.Types
open OnlineDPR.Application.Client.Report
open OnlineDPR.Application.Client.Template
open OnlineDPR.Application.Shared

open Elmish
open Elmish.Debug
open Elmish.React

open Fable.React

let root model dispatch =
    let pageHtml = function
    | ReportPageModel m -> Report.view m (ReportMessage >> dispatch)
    | UserSyncPageModel m -> UserSync.view m (UserSyncMessage >> dispatch)
    | DprInputModel m -> DprInput.view m (UserDataInputMessage >> dispatch)
    | BwaInputModel m -> BwaInput.view m (BwaInputMessage >> dispatch)
    | ControlPanelModel m -> ControlPanel.view m (ControlPanelMessage >> dispatch)
    | ControlPanelBwaModel m -> ControlPanelBwa.view m (ControlPanelBwaMessage >> dispatch)
    | ControlPanelDprModel m -> ControlPanelDpr.view m (ControlPanelDprMessage >> dispatch)
    | UpdateTranslationsModel m -> UpdateTranslations.view m (UpdateTranslationsMessage >> dispatch)
    | BwaOverviewModel m -> BwaOverview.view m (BwaOverviewMessage >> dispatch)
    | ClubListModel m -> ClubList.view m (ClubListMessage >> dispatch)
    | InvoicesModel m -> Invoices.view m (InvoicesMessage >> dispatch)
    | DprAdministrationModel m -> DprAdministration.view m (DprAdministrationMessage >> dispatch)
    | _ ->  templateView Template.Empty [] [] (str "")

    div [] [ (pageHtml model.PageModel) ]

// App
Program.mkProgram init update root
|> Program.withConsoleTrace
|> Program.withReactBatched "elmish-app"
|> Program.run